/**
 * A simple handlers to create easily reducers
 * @param [Any] initialState
 * @param [Object] handlers, Object where each key is a function
 *
 * @return [Object]
 */
export function createReducer(initialState, handlers) {
  /**
   * A handlers to
   * @param [Any] currentState, Current status for a reducer.
   * @param [Object] action
   *
   * @return [Any] New state for a reducer
   */
  return function reducer(state = initialState, action) {
    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
      return handlers[action.type](state, action)
    } else {
      return state
    }
  }
}

/**
 * Create new state
 * @param {Object} oldState
 * @param {Object} newValues?
 */
export function updateState(oldState, newValues = {}) {
  return Object.assign({}, oldState, newValues)
}
